import React from "react";
import "./Super_admin_creator_packages.css";

export default function Superadmincreatorpackages() {
  return <div>superadmincreatorpackages</div>;
}
